module.exports = __webpack_public_path__ + "static/media/slide1.1c87d157.jpg";